import { dictionary, patterns } from "./dictionary";

function capitalize(source: string, translation: string): string {
    if (source === source.toUpperCase()) {
      return translation.toUpperCase(); 
    }
    if (source === source.toLowerCase()) {
      return translation.toLowerCase(); 
    }
    if (source[0] === source[0].toUpperCase()) {
      return translation[0].toUpperCase() + translation.slice(1); 
    }
    return translation; 
}
  

export function translateText(
    text: string,
    toLanguage: string
  ): string {
    const source = dictionary[text.toLowerCase()];
    if (source && source[toLanguage]) {
      const translation = source[toLanguage];
      return capitalize(text, translation);
    }
    return text;
  }
  

 export function translateRegexMessage(message: string, toLanguage: string): string {
    for (const { pattern, key, vars } of patterns) {
      const match = message.match(pattern);
      if (match) {
        const values = match.slice(1);
        let translation = dictionary[key]?.[toLanguage];
        if (!translation) break;
  
        vars.forEach((varName, i) => {
          translation = translation.replace(`{${varName}}`, values[i]);
        });
  
        return translation;
      }
    }
  
    return message; 
  }